<style lang="scss" scoped>
  @import '../../../sass/utilities/variables';

  .page-container {
    width: 80rem;
    margin: 5rem auto;
    padding-bottom: 6rem;
  }

  .header-container {
    padding-bottom: 3rem;
    border-bottom: 1px solid $light-silver;
  }

  .title-text {
    font-weight: 300;
    font-style: normal;
    font-size: 3rem;
    color: $dark-grey;
  }

  .description-text {
    margin-top: 1.5rem;
    font-weight: 400;
    font-style: normal;
    font-size: 1.4rem;
    color: $dark-grey;
  }

  .no-jobs-text {
    padding: 3rem;
    text-align: center;
    font-weight: bold;
  }
</style>
<template>
  <div
    class="page-container"
    v-if="pageLoaded"
  >
    <div class="header-container">
      <div class="title-text">
        {{ titleText }}
      </div>
      <div class="description-text">
        {{ descriptionText }}
      </div>
    </div>
    <div v-if="hasJobs">
      <div v-for="job in this.jobs.itemListElement">
        <job-card
          :data="job"
          :hex-color="employerSettings.hexColor"
        >
        </job-card>
      </div>
    </div>
    <div
      v-else
      class="no-jobs-text"
    >
      {{ noJobsText }}
    </div>
  </div>
</template>
<script>
import ApiRequest from '../../../js/api-request';
import JobCard from './job-card.vue';

export default {
  data() {
    return {
      jobs: [],
      employerSettings: {
        uid: '',
        employerName: '',
        hexColor: '',
      },
      pageLoaded: false,
    };
  },

  created() {
    this.getEmployerCareersPageSettings();
  },

  computed: {
    hasJobs() {
      return this.jobs.itemListElement.length > 0;
    },

    titleText() {
      if (this.employerSettings.employerName === '') {
        return '';
      }

      return `${this.employerSettings.employerName} is always looking for talented people.`;
    },

    noJobsText() {
      return `Sorry, there are no current job openings at ${this.employerSettings.employerName}.`;
    },

    descriptionText() {
      return 'We believe our success is driven by passionate,'
       + ' innovative, and skilled individuals.'
       + ' If you\'re excited about the possibility'
       + ' of making a difference and growing with us,'
       + ' we\'d love to hear from you!';
    },

    urlHash() {
      const url = window.location.pathname;
      const segments = url.split('/');

      return segments.pop() || segments.pop();
    },
  },

  methods: {
    getEmployerCareersPageSettings() {
      new ApiRequest(`/api/careers-page/employer-details/${this.urlHash}`,
        (data) => {
          this.employerSettings = data;
          this.pageLoaded = true;
        },
        (error) => {
          console.error(error);
        }).get();
    },
  },

  mounted() {
    this.jobs = JSON.parse(document.getElementById('job-data').textContent);
  },

  components: {
    JobCard,
  },
};
</script>
